<template>
  <b-row>
    <b-col cols="12">
      <b-row>
        <b-col cols="12">
          <b-card>
            <b-row
              class="mb-50"
              align-h="center"
            >
              <b-col cols="auto">
                <div style="display: flex;">
                  <h4>
                    Índice geral de cobranças</h4>
                  <div style="padding-left: 0.4rem">
                    <i
                      v-b-tooltip.hover
                      title="Nesse índice é consolidado todos os documentos cobrados até a data atual de todas as equipes"
                      style="font-size: 0.85rem;"
                      class="question-icon"
                    >
                      <font-awesome-icon
                        :icon="faQuestionCircle"
                      />
                    </i>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col>
                <span style="margin-bottom: 0.8rem">
                  Total geral: {{ totalDocumentos }} [100%]</span>
              </b-col>
            </b-row>
            <totalizador-documentos />
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card>
            <detalhamento-status-equipe />
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-card>
            <entrega-documento-equipe />
          </b-card>
        </b-col>
        <b-col cols="6">
          <b-card>
            <indice-empresas />
          </b-card>
          <b-card>
            <configuracao-cobranca />
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card>
            <configuracao-cobranca-tabela />
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'
import api from './shared/services/api'

export default {
  name: 'DashboardCobranca',
  components: {
    FontAwesomeIcon,
    TotalizadorDocumentos: () => import('./shared/components/totalizador-documentos/TotalizadorDocumentos.vue'),
    EntregaDocumentoEquipe: () => import('./shared/components/entrega-documentos-equipe/EntregaDocumentosEquipe.vue'),
    DetalhamentoStatusEquipe: () => import('./shared/components/detalhamento-status-equipe/DetalhamentoStatusEquipe.vue'),
    IndiceEmpresas: () => import('./shared/components/indice-empresas/IndiceEmpresas.vue'),
    ConfiguracaoCobranca: () => import('./shared/components/configuracao-cobranca/ConfiguracaoCobranca.vue'),
    ConfiguracaoCobrancaTabela: () => import('./shared/components/configuracao-cobranca/configuracao-cobranca-tabela/ConfiguracaoCobrancaTabela.vue'),
  },
  data() {
    return {
      faQuestionCircle,
      totalDocumentos: 0,
    }
  },
  created() {
    this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', true)
    this.aplicar()
  },
  destroyed() {
    this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', false)
  },
  methods: {
    aplicar() {
      api.getDadosIniciais()
        .then(payload => {
          this.totalDocumentos = payload.data
        })
    },
  },
}
</script>
